import { QueryKey, useMutation, useQueryClient } from "react-query"
import { InfiniteState } from "./types"

/**
 *
 * @param queryKey
 * @param dataFn A function to load the data
 * @param mutateFn A function which should return the mutated list items with the edited item
 * @returns UseMutationResult
 */
export function useEditCustomItem<TRequest, TResponse, TItem>(
    queryKey: QueryKey,
    dataFn: (request: TRequest) => Promise<TResponse>,
    mutateFn: (response: TResponse, request: TRequest, prevData: TItem[]) => TItem[]
) {
    const queryClient = useQueryClient()

    return useMutation<TResponse, unknown, TRequest>(dataFn, {
        onSuccess: (response, request) => {
            queryClient.setQueriesData<InfiniteState<TItem[]>>(queryKey, (prev) => {
                return {
                    ...prev,
                    pages:
                        prev?.pages.map((page) => ({
                            ...page,
                            data: mutateFn(response, request, page.data),
                        })) ?? [],
                }
            })
        },
    })
}
